module.exports = __webpack_public_path__ + "fonts/heebo-v9-latin-900.ead58630.woff2";